/**
 * RetentionFitBadge — coloured percentage badge showing how well an employee's
 * DISC profile matches the company's Good Leaver pattern.
 *
 *   ≥ 70 %  → Green  ("strong fit")
 *   25-69 % → Amber  ("mixed")
 *   < 25 %  → Red    ("bad-leaver pattern")
 *
 * Hover for a quick breakdown of which DISC dimensions are pulling the score.
 */

const COLOURS = {
  green: { bg: "#dcfce7", fg: "#15803d", ring: "#10b981" },
  amber: { bg: "#fef3c7", fg: "#a16207", ring: "#f59e0b" },
  red:   { bg: "#fee2e2", fg: "#b91c1c", ring: "#e11d48" },
};

const SIZE = {
  sm: { width: 56,  height: 22, pct: 12,   pad: "2px 8px"  },
  md: { width: 72,  height: 28, pct: 13.5, pad: "3px 12px" },
  lg: { width: 110, height: 36, pct: 18,   pad: "4px 14px" },
};

export default function RetentionFitBadge({ fit, size = "md", title }) {
  if (!fit || typeof fit.score !== "number") {
    return (
      <span
        className="ei-fit-badge ei-fit-badge-empty"
        title="Not enough leaver data yet — tag 3+ Good and 3+ Bad leavers to switch on the model."
        data-testid="ei-fit-badge-empty"
      >
        —
      </span>
    );
  }
  const { score, band, contributions } = fit;
  const palette = COLOURS[band] || COLOURS.amber;
  const dims = (contributions || {});
  const tip = `Retention fit ${score.toFixed(1)}% (${band})\n` +
    `D ${dims.D > 0 ? "+" : ""}${dims.D ?? 0}  ·  ` +
    `I ${dims.I > 0 ? "+" : ""}${dims.I ?? 0}  ·  ` +
    `S ${dims.S > 0 ? "+" : ""}${dims.S ?? 0}  ·  ` +
    `C ${dims.C > 0 ? "+" : ""}${dims.C ?? 0}\n` +
    "Positive = pulls toward good leaver pattern.";
  const dims_size = SIZE[size] || SIZE.md;
  return (
    <span
      className={`ei-fit-badge ei-fit-badge-${band}`}
      style={{
        background: palette.bg,
        color: palette.fg,
        borderColor: palette.ring,
        padding: dims_size.pad,
        fontSize: dims_size.pct,
        minWidth: dims_size.width,
      }}
      title={title || tip}
      data-testid="ei-fit-badge"
    >
      {Math.round(score)}%
    </span>
  );
}
